import React, { useEffect } from 'react';
import Meta from '../components/SEO/Meta';
import { useSelector } from 'react-redux';
import HeroSection from '../components/HeroSection';
import WhoWeAreSection from '../components/WhoWeAreSection';
import ServicesSection from '../components/ServicesSection';
import BlogSection from '../components/BlogSection';
import SectionWrapper from '../components/SectionWrapper';
import TeamSection from '../components/TeamSection';
import PartnersSection from '../components/PartnersSection';
import ApplyProject from '../components/ApplyProject';

const Home = ({ setBgColor, colors }) => {
  
  const { info: adminInfo } = useSelector((state) => state.adminInfo);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const homeSchema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "NGO",
        "@id": "https://ssi.org.tr/#organization",
        "name": "SSI Association",
        "alternateName": ["Sustainable Solutions Initiative", "SSI", "SSI Turkey"],
        "image": "https://res.cloudinary.com/dpuo4ow5h/image/upload/v1758372063/pisikoloji_web/hep6j7kzjyq28gltfwj1.png",
        "logo": {
          "@type": "ImageObject",
          "url": "https://res.cloudinary.com/dpuo4ow5h/image/upload/v1758372063/pisikoloji_web/hep6j7kzjyq28gltfwj1.png",
          "width": 512,
          "height": 512
        },
        "url": "https://ssi.org.tr",
        "email": "sustainablesolutionsinitiative@gmail.com",
        "description": "SSI Association is a leading youth-focused NGO in Turkey specializing in EU-funded projects, Erasmus+ programmes, youth exchanges, and international mobility initiatives across Europe.",
        "slogan": "Empowering Youth Through Sustainable Innovation",
        "foundingDate": "2024",
        "foundingLocation": {
          "@type": "Place",
          "name": "Bursa, Turkey"
        },
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Bursa",
          "addressRegion": "Nilufer",
          "addressCountry": "TR"
        },
        "areaServed": [
          { "@type": "Place", "name": "European Union" },
          { "@type": "Place", "name": "Turkey" },
          { "@type": "Place", "name": "Balkans" },
          { "@type": "Place", "name": "Mediterranean Region" }
        ],
        "knowsAbout": [
          "Erasmus+ Programme",
          "EU Youth Projects",
          "KA1 Learning Mobility",
          "KA2 Strategic Partnerships",
          "KA3 Policy Reform",
          "European Solidarity Corps",
          "Youth Exchanges",
          "Training Courses for Youth Workers",
          "International Mobility Projects",
          "Youth Empowerment",
          "Sustainable Development Goals",
          "Cultural Exchange Programmes",
          "Non-formal Education",
          "Intercultural Learning",
          "European Youth Programmes",
          "Volunteering Projects",
          "Capacity Building"
        ],
        "memberOf": [
          {
            "@type": "Organization",
            "name": "Erasmus+ Programme",
            "url": "https://erasmus-plus.ec.europa.eu/"
          },
          {
            "@type": "Organization",
            "name": "European Solidarity Corps",
            "url": "https://youth.europa.eu/solidarity_en"
          }
        ],
        "numberOfEmployees": {
          "@type": "QuantitativeValue",
          "value": "10+"
        },
        "award": "30+ Completed EU Projects"
      },
      {
        "@type": "WebSite",
        "@id": "https://ssi.org.tr/#website",
        "url": "https://ssi.org.tr",
        "name": "SSI Association - EU Projects & Youth Mobility Turkey",
        "description": "Official website of SSI Association - Your partner for Erasmus+ projects, youth exchanges, and EU-funded initiatives in Turkey",
        "publisher": {
          "@id": "https://ssi.org.tr/#organization"
        },
        "inLanguage": "en-US",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://ssi.org.tr/search?q={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      },
      {
        "@type": "WebPage",
        "@id": "https://ssi.org.tr/#webpage",
        "url": "https://ssi.org.tr",
        "name": "SSI Association - Erasmus+ & EU Youth Projects Turkey",
        "isPartOf": {
          "@id": "https://ssi.org.tr/#website"
        },
        "about": {
          "@id": "https://ssi.org.tr/#organization"
        },
        "description": "SSI Association: Leading NGO for EU-funded youth projects, Erasmus+ programmes, international exchanges, and sustainable development initiatives in Turkey and across Europe.",
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://ssi.org.tr"
            }
          ]
        }
      }
    ]
  };

  return (
    <>
      <Meta 
        title="SSI Association | Erasmus+ Projects & EU Youth Mobility Turkey"
        description="SSI Association is a leading Turkish NGO specializing in EU-funded projects: Erasmus+ Youth Exchanges, Training Courses, KA1 & KA2 programmes. 30+ completed projects across Europe. Partner with us for international youth mobility."
        schema={homeSchema}
        keywords="Erasmus+ Turkey, EU projects Turkey, youth exchange programmes, KA1 mobility projects, KA2 strategic partnerships, European Solidarity Corps Turkey, youth NGO Turkey, international youth projects, Erasmus+ partner Turkey, EU funded projects, youth mobility, training courses Europe, non-formal education"
      />
      <main className="overflow-hidden">
        <SectionWrapper setColor={setBgColor} color={colors[0]}>
          <HeroSection />
        </SectionWrapper>
        <SectionWrapper setColor={setBgColor} color={colors[0]}>
          <WhoWeAreSection />
        </SectionWrapper>

        <BlogSection />
        
        <div className="apply-project-wrap">
          <ApplyProject info={adminInfo} />
        </div>

        <SectionWrapper setColor={setBgColor} color={colors[1]}>
          <ServicesSection />
        </SectionWrapper>
        <SectionWrapper setColor={setBgColor} color={colors[3]}>
          <TeamSection />
        </SectionWrapper>
        <SectionWrapper setColor={setBgColor} color={colors[4]}>
          <PartnersSection />
        </SectionWrapper>
      </main>
    </>
  );
};

export default Home;